<!-- TODO: @later move this section to a separate component -->
<div class="syn-pdf-viewer-top-bar-container">
  <div class="title-container">
    <button mat-icon-button class="back-button" (click)="navigateToReports()">
      <mat-icon>keyboard_backspace</mat-icon>
    </button>
    <div class="title">
      {{ title() }}
    </div>
  </div>

  @if (showShareButton) {
    <div class="actions">
      <syn-social-share [title]="title()" />
    </div>
  }
</div>

<ngx-extended-pdf-viewer
  [filenameForDownload]="pdfName"
  [showDownloadButton]="'always-visible'"
  [showDrawEditor]="false"
  [showFindButton]="false"
  [showHighlightEditor]="false"
  [showOpenFileButton]="false"
  [showPresentationModeButton]="true"
  [showPrintButton]="'always-visible'"
  [showSecondaryToolbarButton]="false"
  [showSidebarButton]="false"
  [showStampEditor]="false"
  [src]="pdfSrc()"
  [textLayer]="true"
  (pdfLoadingStarts)="pdfLoadingStarts($event)"
  showTextEditor="always-in-secondary-menu" />

<!-- TODO: @later implement the custom toolbar once the issue is resolved -->
<!-- <ngx-extended-pdf-viewer
  #pdfViewer
  [customToolbar]="additionalButtons"
  [src]="data.pdfSrc"
  [textLayer]="true">
</ngx-extended-pdf-viewer>

<ng-template #additionalButtons>
  <div id="toolbarViewer" style="background-color: darkblue; color: white;">
    <div id="toolbarViewerLeft">
      <pdf-toggle-sidebar></pdf-toggle-sidebar>
      <div class="toolbarButtonSpacer"></div>
      <pdf-find-button
        [showFindButton]="true"
        [textLayer]="true"></pdf-find-button>
      <pdf-paging-area></pdf-paging-area>
    </div>
    <pdf-zoom-toolbar></pdf-zoom-toolbar>
    <div id="toolbarViewerRight">
      <pdf-open-file></pdf-open-file>
      <pdf-presentation-mode></pdf-presentation-mode>
      <pdf-print></pdf-print>
      <pdf-download></pdf-download>
      <div class="verticalToolbarSeparator hiddenSmallView"></div>
      <pdf-toggle-secondary-toolbar></pdf-toggle-secondary-toolbar>
    </div>
  </div>
</ng-template> -->
